import { Box, Grid, GridItem, Text } from '@chakra-ui/react';

import { Comments } from '$components/ui/comments';
import { Markdown } from '$components/ui/markdown';
import { Links } from '$components/ui/project-card/links';

import { Project } from '.';

interface ContentProps {
  project: Project;
}

const metaLabelSx = {
  fontFamily: 'mono',
  fontSize: '11px',
  letterSpacing: '0.16em',
  textTransform: 'uppercase' as const,
  color: 'text.faint',
};

export function Content({ project }: ContentProps) {
  return (
    <Box mt="48px">
      <Grid
        templateColumns={{ base: '1fr', md: '120px 1fr' }}
        gap={{ base: '12px', md: '24px' }}
        py="24px"
        borderTopWidth="1px"
        borderBottomWidth="1px"
        borderColor="line.subtle"
      >
        <GridItem>
          <Text sx={metaLabelSx}>Stack</Text>
        </GridItem>
        <GridItem>
          <Text fontFamily="mono" fontSize="13px" color="text.primary">
            {project.techs.join(' · ')}
          </Text>
        </GridItem>

        <GridItem>
          <Text sx={metaLabelSx}>Links</Text>
        </GridItem>
        <GridItem>
          <Links url={project.url} repository={project.repository} />
        </GridItem>
      </Grid>

      <Box mt="56px">
        <Markdown>{project.description}</Markdown>
      </Box>

      <Box
        mt="80px"
        pt="40px"
        borderTopWidth="1px"
        borderColor="line.subtle"
        sx={{
          '.utterances': { maxWidth: '100%', mx: 0 },
        }}
      >
        <Text sx={metaLabelSx} mb="20px">
          Discussion
        </Text>
        <Comments />
      </Box>
    </Box>
  );
}
